import { Pipe, PipeTransform } from '@angular/core';
import { UserProvider } from '../../providers/user/user';
import * as _ from 'lodash';

/**
 * Generated class for the UsernameOrYouPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'userReportedReview',
})
export class UserReportedReviewPipe implements PipeTransform {
  constructor(public user: UserProvider) {}

  /**
   * Takes a value and makes it lowercase.
   */
  transform(userId, review) {
    console.log(
      'user and review',
      userId,
      review,
      _.includes(review.usersReported, userId)
    );
    if (_.includes(review.usersReported, userId)) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/user-reported-review/user-reported-review.ts